import { ConfirmDialog } from '../../../components/confirm-dialog';
import { t } from '../../../lib/i18n';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

/**
 * The clients feature's confirmation dialog — now a thin adapter over the
 * app-wide ConfirmDialog, so it wears the admin's design tokens (brand
 * primary, cf-line outline) instead of the web port's blue/gray. The props are
 * kept so its four callers did not have to change.
 */
export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  isLoading = false,
}: ConfirmationModalProps) {
  return (
    <ConfirmDialog
      open={isOpen}
      title={title}
      message={message}
      confirmLabel={isLoading ? t('common.loading.default') : (confirmText ?? t('common.confirm'))}
      cancelLabel={cancelText}
      busy={isLoading}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
}
